import ReqError from "@source/api/reqError";
import { api } from "@source/api/http";
import { ISectionGroup } from "@source/api/models/sectionGroupModels";

export default class SectionGroupService {
  static async getByNursingHome(nursingHomeId: string) {
    try {
      return (await api.get<ISectionGroup[]>(`section-group/nursingHome/${nursingHomeId}`)).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if (downError) {
        throw downError;
      }
      throw e;
    }
  }
}
